module.exports = __webpack_public_path__ + "media/components/country-flag/static/tr-127f3fc579ff14f38b508f971e82db66.svg";